import styled from 'styled-components'

export const PostTitle = styled.h2({
  marginBottom: 'var(--spacing-s)'
})

export const Post = styled.div({
  marginBottom: '40px'
})
